export enum Severity {
  ERROR = 'ERROR',
  CRITICAL = 'CRITICAL',
}

export interface IAuth0Error {
  code: string;
  message: string;
}

export interface IAuth0ParseError {
  error: string;
  errorDescription: string;
}

export interface IError {
  body: string;
  errorCode?: string;
  heading: string;
  severity?: Severity;
}

export interface IServletError {
  body: string;
  errorCode: string;
}

export interface IAxiosError {
  code: string;
}

export interface IRegisterContent {
  heading: string;
  accountNumberLabel: string;
  accountNumberPlaceholder: string;
  forgotAccountNumberLabel: string;
  submitLabel: string;
}

export interface IContent {
  register: IRegisterContent;
  errors: {
    [key: string]: IError;
  };
}

export interface ILoginPayload {
  username: string;
  password: string;
  rememberMe: boolean;
}

export interface IAuthResult {
  accessToken?: string;
  idToken?: string;
  expiresIn?: string;
  idTokenPayload: object;
}

export interface IAuth0LocalStorage {
  accessToken: string;
  expiresAt: number;
  idToken: string;
}

export interface ISumoLoggerWindow {
  SLLogger?: any;
  SumoLogger?: any;
}

export interface ILoggingConfig {
  enabled: boolean;
  endpoint: string;
  sourceCategory: string;
  sourceName?: string;
  sendErrors?: boolean;
}

export interface IPathsConfig {
  forgotEmailAddressHref: string;
  forgotPasswordHref: string;
  homepageHref: string;
  registerHref: string;
  activationHref: string;
}

export interface IFeatureToggleConfig {
  mobileActivation: boolean;
}

export interface IDapiConfig {
  apiKey: string;
  apiPath: string;
}
